import React from 'react'

type PrinterMarksProps = {
  trimLeft: number
  trimTop: number
  trimWidth: number
  slugHeight?: number
}

// Minimal slug/marks band centered above the trim, inside the bleed area
const PrinterMarks: React.FC<PrinterMarksProps> = ({
  trimLeft,
  trimTop,
  trimWidth,
  slugHeight = 12,
}) => {
  const top = Math.max(0, trimTop - slugHeight - 2)

  return (
    <div
      className="doc-printer-band"
      style={{
        left: trimLeft,
        top,
        width: trimWidth,
        height: slugHeight,
      }}
    />
  )
}

export default PrinterMarks
